import { render, staticRenderFns } from "./activeDiscount.vue?vue&type=template&id=becb75a8&scoped=true&"
import script from "./activeDiscount.vue?vue&type=script&lang=js&"
export * from "./activeDiscount.vue?vue&type=script&lang=js&"
import style0 from "./activeDiscount.vue?vue&type=style&index=0&id=becb75a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becb75a8",
  null
  
)

export default component.exports